import AxiosClient from "../../../services/axios.services";

class FactorsCriteriaServices {
  getFactorsCriteria = params =>
    AxiosClient.get("/api/app/aceptacion_pantalla_factores/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getFactorCriterion = id =>
    AxiosClient.get(`/api/app/aceptacion_pantalla_factores/${id}/`, {
      headers: { "Content-Type": "application/json" },
  });
  saveFactorCriterion = req =>
    AxiosClient.post("/api/app/aceptacion_pantalla_factores/", req, {
      headers: { "Content-Type": "application/json" },
    });
  editFactorCriterion = (id, req) =>
    AxiosClient.put(`/api/app/aceptacion_pantalla_factores/${id}/`, req, {
      headers: { "Content-Type": "application/json" },
    });
  deleteFactorCriterion = id =>
    AxiosClient.delete(`/api/app/aceptacion_pantalla_factores/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new FactorsCriteriaServices();